module.exports = __webpack_public_path__ + "img/icey-active.8bc712cf.png";